function FieldLabel({ label }) {
 return <span className="mb-2 block text-sm font-bold text-dark">{label}</span>;
}

export function Input({ label, id, className = "", optional = false, placeholder, ...props }) {
 return (
  <label htmlFor={id} className="block">
   <FieldLabel label={label} />
   <input
    id={id}
    placeholder={placeholder || (optional ? "Optional" : undefined)}
    className={`w-full rounded-xl border border-line bg-white px-4 py-3 text-sm text-body transition placeholder:text-slate-400 focus:border-primary focus:ring-2 focus:ring-emerald-100 ${className}`}
    {...props}
   />
  </label>
 );
}

export function Textarea({ label, id, className = "", optional = false, placeholder, ...props }) {
 return (
  <label htmlFor={id} className="block">
   <FieldLabel label={label} />
   <textarea
    id={id}
    placeholder={placeholder || (optional ? "Optional" : undefined)}
    className={`min-h-32 w-full rounded-xl border border-line bg-white px-4 py-3 text-sm text-body transition placeholder:text-slate-400 focus:border-primary focus:ring-2 focus:ring-emerald-100 ${className}`}
    {...props}
   />
  </label>
 );
}